import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M19.2 13.2C19.2 13.86 18.66 14.4 18 14.4H13.2C11.88 14.4 10.8 13.32 10.8 12V6C10.8 5.34 11.34 4.8 12 4.8C12.66 4.8 13.2 5.34 13.2 6V10.8C13.2 11.46 13.74 12 14.4 12H18C18.66 12 19.2 12.54 19.2 13.2ZM24 12C24 18.624 18.624 24 12 24C5.376 24 0 18.624 0 12C0 5.376 5.376 0 12 0C18.624 0 24 5.376 24 12ZM21.6 12C21.6 6.708 17.292 2.4 12 2.4C6.708 2.4 2.4 6.708 2.4 12C2.4 17.292 6.708 21.6 12 21.6C17.292 21.6 21.6 17.292 21.6 12Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
